import angular from 'angular';
import angularFileSaver from 'angular-file-saver';

import ordinalfilter from './ordinalfilter';
import prettydecimal from './prettydecimal';
import storeselector from './storeselector';
import exportButton from './exportbutton';
import periodPicker from './periodpicker';
import loadingindicator from './loadingindicator';

const commonComponents = angular.module('common-components', [
    angularFileSaver
]);

commonComponents.directive('storeselector', storeselector);
commonComponents.filter('ordinal', ordinalfilter);
commonComponents.filter('prettydecimal', prettydecimal);
commonComponents.directive('exportButton', exportButton);
commonComponents.directive('periodPicker', periodPicker);
commonComponents.directive('loadingindicator', loadingindicator);

export default commonComponents.name;



// WEBPACK FOOTER //
// ./src/js/components/common/index.js